
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/totem",
      function () {
        return require("private-next-pages/totem/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/totem"])
      });
    }
  